import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useT } from "@/i18n/useT";

export default function Newsletter({ inverse = false }) {
  const t = useT();
  const n = t.newsletter;
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try { await api.post("/newsletter", { email }); toast(n.success); setEmail(""); }
    catch { toast(n.error); }
    finally { setLoading(false); }
  };

  const inputCls = inverse ? "w-full bg-transparent border-b border-cream/30 px-0 py-3 text-sm text-cream placeholder:text-cream/40 focus:outline-none focus:border-amber" : "br-input";
  const btnCls = inverse ? "text-[11px] uppercase tracking-[0.3em] text-amber hover:text-cream transition-colors" : "text-[11px] uppercase tracking-[0.3em] text-espresso hover:text-walnut transition-colors";

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="space-y-3">
      <p className={`text-sm font-light ${inverse ? "text-cream/70" : "text-walnut"}`}>{n.hint}</p>
      <div className="flex items-end gap-3">
        <input data-testid="newsletter-email" type="email" required placeholder={n.placeholder} value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
        <button data-testid="newsletter-submit" type="submit" disabled={loading} className={btnCls}>{loading ? n.loading : n.join}</button>
      </div>
    </form>
  );
}